module.exports = __webpack_public_path__ + "static/media/icon_nav_on_home.70a44ffb.svg";